<section class="bg-neutral-50 dark:bg-neutral-900 flex min-h-screen">
  <!-- min-w-0 lets this flex item shrink to the viewport instead of adopting
       wide content's intrinsic width (which would make the whole page scroll
       horizontally); wide tables scroll inside their own overflow containers -->
  <div class="flex-grow min-w-0">
    @if (isLoggedIn === undefined) {
      <app-loading-spinner></app-loading-spinner>
    } @else if (isLoggedIn) {
      <app-main></app-main>
    } @else {
      <app-login></app-login>
    }
  </div>
</section>
